export const FILL = '#000001'

export const CIRCLE = {
  radius: 50,
  left: 100,
  top: 100,
  fill: FILL,
  strokeUniform: true,
}

export const RECTANGLE = {
  left: 100,
  top: 100,
  fill: FILL,
  width: 40,
  height: 40,
  angle: 0,
  strokeUniform: true,
}

export const TRIANGLE = {
  left: 100,
  top: 100,
  fill: FILL,
  width: 40,
  height: 40,
  angle: 0,
  strokeUniform: true,
  id: 'triangle',
}

export const LINE = {
  points: [50, 100, 200, 200],
  options: {
    left: 170,
    top: 150,
    strokeUniform: true,
  },
}

export const TEXT = {
  type: 'text',
  left: 100,
  top: 100,
  fontSize: 16,
  fontFamily: 'Arial',
  fill: FILL,
  strokeUniform: true,
}
